export default __webpack_public_path__ + "9ec24c50410b6d5138b7839241644263.woff2";